import { render, staticRenderFns } from "./ZillowTerms.vue?vue&type=template&id=252da890&"
import script from "./ZillowTerms.vue?vue&type=script&lang=js&"
export * from "./ZillowTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports